<div
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutAlign.xs="space-between end"
  fxLayoutAlign="space-between center"
  fxLayoutGap="8px"
>
  <h1 class="wai-page-header-label" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <ng-content></ng-content>
  </h1>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
    <ng-content select="[slot=additional]"></ng-content>
    <ng-content select="[slot=actions]"></ng-content>
  </div>
</div>
